import React from 'react';

const Footer = () => {
  return (
    <footer id="footer-copyright" className="footer-copyright">
      <div className="container">
        <div className="hm-footer-copyright text-center">
          <p>&copy; 2024 Jashwanth SA | All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 